module.exports = "/images/hidden_grey.png?dc435b8c572d83666c0dc4da8f28fd84";